/* eslint-disable arrow-body-style */
import http from '@/utils/http';

export const getOpinionFilterCond: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/opinion_pc/filter/cond',
    method: 'post',
    data: payload
  }) as Promise<any>
}

export const fetchTopicWithTop: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/opinion_pc/getTopicWithTop',
    method: 'post',
    data: payload
  })
}

export const getTopicStatsTimeline: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/opinion_pc/overview/topic_stats_timeline',
    method: 'post',
    data: payload
  }) as Promise<any>
}

export const getTopicFeedsComments: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/opinion_pc/feeds/comments',
    method: 'post',
    data: payload
  }) as Promise<any>
}